<div class="verification-container">
  <div class="verification-box">
    <div class="logo-container">
      <img alt="Growth99 Logo" class="logo" [src]="g99ColoredLogo" />
    </div>
    <div class="image-container">
      <img alt="Verification Illustration" [src]="mfaThumbnail" />
    </div>

    <div *ngIf="!completedMfaSetupMethod" class="content-container">
      <h2>Set Up Two-Factor Authentication</h2>
      <p>
        To enhance the security of your account, enable two-factor
        authentication (2FA). This will require a second form of verification in
        addition to your password whenever you log in.
      </p>
      <p class="phone-number">Choose your 2FA method:</p>

      <!-- Authentication App Option -->
      <div
        class="option-selection"
        [ngClass]="{
          'selected-border': selectedAuthenticationMethod === 'totp',
        }"
        (click)="onAuthenticationMethodSelect('totp')"
      >
        <span class="selected">
          <i class="fa fa-check"></i>
        </span>
        <div class="radio-option">
          <p class="phone-number">Authentication App</p>
        </div>
        <ul>
          <li
            >Download an authentication app (like Google Authenticator, Authy,
            etc.) on your mobile device.</li
          >
          <li
            >Scan the QR code with your authentication app to generate a unique
            code.</li
          >
          <li>Enter the code from the app to complete setup.</li>
        </ul>
      </div>

      <!-- Uncomment if SMS Verification is needed -->
      <!--
            <div class="option-selection" (click)="onselectedAuthenticationMethod('sms')" 
                 [ngClass]="{ 'selected-border': isSelected('sms') }">
                <span class="selected">
                    <i class="fa fa-check"></i>
                </span>
                <p class="phone-number">SMS Verification</p>
                <ul>
                    <li>Enter your mobile phone number to receive verification codes via SMS.</li>
                    <li>Each time you log in, you will receive a code by text message to verify your identity.</li>
                </ul>
            </div>
            -->

      <g99-button
        width="100%"
        variant="medium"
        color="green"
        [disabled]="!selectedAuthenticationMethod"
        [loadingText]="'Verifying...'"
        [isLoading]="isLoading"
        (buttonClick)="onVerifyAuthenticationMethod()"
      >
        Continue
      </g99-button>

      <!-- Additional Options -->
      <g99-auth-additional-option-footer />
    </div>

    <!-- TOTP Setup -->
    <ng-container *ngIf="completedMfaSetupMethod === 'totp'">
      <div class="content-container">
        <g99-totp-setup
          [accessToken]="accessToken"
          [otpAuthUrl]="otpAuthUrl"
          (emitChangeAuthMethod)="onAuthenticationMethodSelect('')"
        />
      </div>
    </ng-container>
  </div>
</div>
